import { render, staticRenderFns } from "./InstructionSubject.vue?vue&type=template&id=9aa4a5ca"
import script from "./InstructionSubject.vue?vue&type=script&lang=js"
export * from "./InstructionSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports